<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="col-sm-6 float-left">
            <h1 class="page-title">Plan Package List</h1>
        </div>
        <div class="col-sm-6 float-left add_user_btn">
            <a routerLink="/create-plan-package" class="btn btn-success">
                <i class="fa fa-plus" aria-hidden="true"></i> Add Plan Package
            </a>
        </div>
    </div>

    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row mb-4 mt-4">
                    <div class="col-sm-3">
                        <input class="form-control" type="text" [(ngModel)]="search" placeholder="Search Plan Name" />
                    </div>
                    <button type="button" class="btn btn-primary ml-2 mb-4" (click)="loadPlanPackageList(0,perpage)">
                        <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                    <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i
                            class="fa fa-sync"></i> Reset Filters</button>

                </div>

            </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3"><button type="button" class="btn btn-success" [disabled]="loading"
                        (click)="loadPlanPackageList(0,perpage)"><i class="fa fa-sync"
                            [ngClass]="{'fa-spin':loading}"></i>
                        Refresh List</button>
                </div>
                <div class="col-sm-6">
                    <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions"
                        [pageSize]="perpage"
                        (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex">
                    </mat-paginator>
                </div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 50px;">#</th>
                            <th>Plan Name </th>
                            <th>Plan Amount</th>
                            <th>Plan Mrp Amount</th>
                            <th>Plan Amount For Member</th>
                            <th>Status </th>
                            <th>Test Name Availed</th>
                            <th>Online Gp</th>
                            <th>Online Surgeon</th>
                            <th>Online Dentists</th>
                            <th>Surgeon Opd</th>
                            <th>Dentist Opd</th>
                            <th>Tests (discount %)</th>
                            <th>Aligners (discount %)</th>
                            <th style="width: 100px;">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let Plan_package of planList;let index = index;">
                            <td>{{(pageIndex*perpage)+index+1}}</td>
                            <td>{{Plan_package.plan_name}} </td>
                            <td>{{Plan_package.plan_amount}} </td>
                            <td>{{Plan_package.plan_mrp_amount}} </td>
                            <td>{{Plan_package.plan_amount_for_member}} </td>
                            <td>
                                <span class="badge bg-green-light" *ngIf="Plan_package.status=='1'">Active</span>
                                <span class="badge bg-azure-light" *ngIf="Plan_package.status=='0'">In-Active</span>
                            </td>
                            <td>
                                <span class="badge bg-green-light"
                                    *ngIf="Plan_package.test_name_availed=='1'">Yes</span>
                                <span class="badge bg-azure-light" *ngIf="Plan_package.test_name_availed=='2'">No</span>
                            </td>
                            <td>
                                <span class="badge bg-green-light" *ngIf="Plan_package.online_gp=='1'">Yes</span>
                                <span class="badge bg-azure-light" *ngIf="Plan_package.online_gp=='2'">No</span>
                            </td>
                            <td>
                                <span class="badge bg-green-light" *ngIf="Plan_package.online_surgeon=='1'">Yes</span>
                                <span class="badge bg-azure-light" *ngIf="Plan_package.online_surgeon=='2'">No</span>
                            </td>
                            <td>
                                <span class="badge bg-green-light" *ngIf="Plan_package.online_dentists=='1'">Yes</span>
                                <span class="badge bg-azure-light" *ngIf="Plan_package.online_dentists=='2'">No</span>
                            </td>
                            <td>
                                <span class="badge bg-green-light" *ngIf="Plan_package.surgeon_opd=='1'">Yes</span>
                                <span class="badge bg-azure-light" *ngIf="Plan_package.surgeon_opd=='2'">No</span>
                            </td>
                            <td>
                                <span class="badge bg-green-light" *ngIf="Plan_package.dentist_opd=='1'">Yes</span>
                                <span class="badge bg-azure-light" *ngIf="Plan_package.dentist_opd=='2'">No</span>
                            </td>
                            <td>{{Plan_package.discount_tests}} </td>
                            <td>{{Plan_package.aligners}} </td>
                            <td>
                                <div class="dropdown">
                                    <button class="btn btn-secondary dropdown-toggle" type="button"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Action
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item"
                                            routerLink="/update-plan-package/{{Plan_package.id}}"><i
                                                class="fa fa-pen"></i> Update</a>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="loading">
                            <td colspan="5" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                        </tr>
                        <tr *ngIf="loaded && !planList.length">
                            <td colspan="5"><i class="far fa-frown"></i> Data not found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage"
                (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>


    </div>
</div>